module.exports = __webpack_public_path__ + "static/img/8.ffa4825.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/app/8.jpg
// module id = arkn
// module chunks = 0